import {Component, Inject, OnInit} from '@angular/core';
import {UtilsService} from "../utils.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SitesSelectorComponent} from "../sites-selector/sites-selector.component";
import {NetworkedUsersSelectorComponent} from "../networked-users-selector/networked-users-selector.component";
import {AssetsSelectorComponent} from "../assets-selector/assets-selector.component";

/**
 * Filter dialog for the Incidents selector. Mirrors the main Incidents list
 * filters so the selector can be narrowed down the same way the register
 * list is.
 */
@Component({
  selector: 'app-incidents-selector-filter',
  templateUrl: './incidents-selector-filter.component.html',
  styleUrls: ['./incidents-selector-filter.component.scss']
})
export class IncidentsSelectorFilterComponent implements OnInit {

  type: string = '';
  status: string = '';
  selected_site_ids: number[] = [];
  selected_user_ids: number[] = [];
  selected_asset_ids: number[] = [];
  date_range: Date[] = [];
  hide_assets: boolean = false;

  constructor(
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<IncidentsSelectorFilterComponent>
  ) { }

  ngOnInit() {
    this.type = this.data['type'] || '';
    this.status = this.data['status'] || '';
    this.selected_site_ids = this.data['site_ids'] || [];
    this.selected_user_ids = this.data['user_ids'] || [];
    this.selected_asset_ids = this.data['asset_ids'] || [];
    this.date_range = (this.data['date_range'] || []).map((date: Date | string) => new Date(date));
    this.hide_assets = this.data['hide_assets'] || false;
  }

  getOutputDateRange($event) {
    this.date_range = $event;
  }

  onSelectSites() {
    this.utils.showComponentDialog(
      SitesSelectorComponent,
      { selected: this.selected_site_ids, multiple: true },
      { width: '1200px' },
      (results) => {
        if (!results) { return; }
        this.selected_site_ids = results;
      }
    );
  }

  onSelectUsers() {
    this.utils.showComponentDialog(
      NetworkedUsersSelectorComponent,
      { selected: this.selected_user_ids, multiple: true, visitors_from_all_sites: true },
      { width: '1200px' },
      (results: number[]) => {
        if (!results) { return; }
        this.selected_user_ids = results;
      }
    );
  }

  onSelectAssets(): void {
    this.utils.showComponentDialog(
      AssetsSelectorComponent,
      { selected: this.selected_asset_ids, multiple: true },
      { width: '1700px' },
      (results: number[]) => {
        if (!results) { return; }
        this.selected_asset_ids = results;
      }
    );
  }

  onClearDateRange() {
    this.date_range = [];
  }

  onClearAndClose() {
    this.type = '';
    this.status = '';
    this.selected_site_ids = [];
    this.selected_user_ids = [];
    this.selected_asset_ids = [];
    this.date_range = [];

    this.onSaveAndClose();
  }

  onSaveAndClose() {
    this.dialogRef.close({
      type: this.type,
      status: this.status,
      site_ids: this.selected_site_ids,
      user_ids: this.selected_user_ids,
      asset_ids: this.selected_asset_ids,
      date_range: this.date_range
    });
  }
}
